// Recovered compiled webpack factory 23781. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { g: () => r });
  var n = i(40042),
    s = i(33182);
  function r(t, e) {
    let i = t.getValue("willChange");
    if ((0, s.S)(i) && i.add) return i.add(e);
    if (!i && n.W.WillChange) {
      let i = new n.W.WillChange("auto");
      (t.addValue("willChange", i), i.add(e));
    }
  }
}
